/* eslint-disable @typescript-eslint/no-explicit-any */
import * as types from "../actionTypes/loginActionTypes";

const initial = {
  loginResponse: {},
  AgentContactDetails: {},
  GstStateCodes: {},
  CountriesCodes: {},
  CitiesCodes: {},
  CurrencyList: {},
  ForgotPasswordResponse: {},
  ResetPasswordResponse: {},
  generatedAccessToken: {},
  ResendOTPResponse: {},
  VerifyOTPResponse: {},
  ChangePasswordResponse: {},
  ResetPasswordLSResponse: {},
};

const LoginReducer = (state = initial, action: any) => {
  switch (action.type) {
    case types.SET_GQL_AUTH_LOGIN.FULLFILLED:
    case types.SET_GQL_AUTH_LOGIN.REJECTED:
    case types.SET_GQL_REFRESH_TOKEN.FULLFILLED:
    case types.SET_GQL_REFRESH_TOKEN.REJECTED:
      return { ...state, loginResponse: action.payload };
    case types.SET_GQL_AUTH_LOGIN.RESET:
      return { ...state, loginResponse: {} };
    case types.SET_GQL_AGENT_CONTACT_DETAILS.FULLFILLED:
      return { ...state, AgentContactDetails: action.payload };
    case types.SET_GQL_GST_STATE_CODE.FULLFILLED:
      return { ...state, GstStateCodes: action.payload };
    case types.SET_GQL_COUNTRIES_CODE.FULLFILLED:
      return { ...state, CountriesCodes: action.payload };
    case types.SET_GQL_CITIES_CODE.FULLFILLED:
      return { ...state, CitiesCodes: action.payload };
    case types.SET_GQL_CURRENCY_LIST.FULLFILLED:
      return { ...state, CurrencyList: action.payload };
    case types.SET_AUTH_LOGOUT:
      return { ...state, loginResponse: {} };
    case types.SET_AUTH_FORGOTPASSWORD.FULLFILLED:
      return { ...state, ForgotPasswordResponse: action.payload };
    case types.RESET_AUTH_FORGOTPASSWORD:
      return { ...state, ForgotPasswordResponse: {} };
    case types.SET_AUTH_RESETPASSWORD.FULLFILLED:
      return { ...state, ResetPasswordResponse: action.payload };
    case types.RESET_AUTH_RESETPASSWORD:
      return { ...state, ResetPasswordResponse: {} };

    case types.SET_AUTH_RESENDOTP.FULLFILLED:
      return { ...state, ResendOTPResponse: action.payload };
    case types.RESET_AUTH_RESENDOTP:
      return { ...state, ResendOTPResponse: {} };

    case types.SET_AUTH_VERIFYOTP.FULLFILLED:
      return { ...state, VerifyOTPResponse: action.payload };
    case types.RESET_AUTH_VERIFYOTP:
      return { ...state, VerifyOTPResponse: {} };

    case types.SET_AUTH_CHANGEPASSWORD.FULLFILLED:
      return { ...state, ChangePasswordResponse: action.payload };
    case types.RESET_AUTH_CHANGEPASSWORD:
      return { ...state, ChangePasswordResponse: {} };

    case types.GENERATE_ACCESS_TOKEN_DETAILS.FULLFILLED:
      return { ...state, generatedAccessToken: action.payload };
    case types.GENERATE_ACCESS_TOKEN_DETAILS.REJECTED:
      return { ...state, generatedAccessToken: action.payload };
    case types.SET_AUTH_RESETPASSWORDLS.FULLFILLED:
      return { ...state, ResetPasswordLSResponse: action.payload };
    case types.RESET_AUTH_RESETPASSWORDLS:
      return { ...state, ResetPasswordLSResponse: {} };
    case "LOGOUT":
      return {
        ...state,
        loginResponse: {}, // clear loginResponse
      };
    default:
      return state;
  }
};

export default LoginReducer;
